import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function RefundPolicy() {
  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="pt-28 pb-16 px-4 md:px-6 bg-background-100">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-4">退款政策</h1>
            <p className="text-sm text-foreground-500">最后更新：2026年6月</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-16 md:py-20 px-4 md:px-6">
          <article className="mx-auto max-w-3xl prose-custom">
            <div className="space-y-12">
              {/* Section 1 - Core Policy */}
              <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50">
                    <i className="ri-error-warning-line text-lg"></i>
                  </div>
                  <h2 className="font-heading text-xl md:text-2xl text-foreground-950">1. 退款基本原则</h2>
                </div>
                <div className="pl-14">
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    <strong>bbgpt.online的课程产品一经购买，默认不予退款。</strong>
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    课程属于数字化知识服务产品，具有即时交付和无限制复制的特性。为了避免资源流失和保障教学公平，我们实行严格的退款管理政策。请在购买前仔细阅读课程介绍、大纲和适用人群说明，确保课程内容与你的学习目标相符。
                  </p>
                </div>
              </div>

              {/* Section 2 - Eligible Situations */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">2. 特殊退款情形</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                  仅在以下特殊情况下，学员可提交退款申请，经审核通过后方可办理退款。所有申请均需提供相应的官方证明文件。
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-hospital-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-2">2.1 长期住院治疗</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                        学员因疾病或意外伤害需长期住院治疗，导致在购课后的课程有效期内无法继续学习。需提供二级甲等及以上医院出具的住院证明和诊断报告。
                      </p>
                      <p className="text-xs text-foreground-400">住院时间需覆盖课程70%以上的有效期</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-heart-pulse-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-2">2.2 重大疾病</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                        学员本人罹患重大疾病，经专业医疗机构确诊，且病情严重到确实无法继续完成课程学习。需提供三级医院出具的诊断证明和治疗记录。
                      </p>
                      <p className="text-xs text-foreground-400">重大疾病范围参照中国保险行业协会定义的28种重大疾病</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-empathize-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-2">2.3 意外事故导致丧失学习能力</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                        学员因意外事故导致身体伤残，经司法鉴定机构评定为伤残等级，确实无法继续学习的情况。需提供司法鉴定报告及相关事故证明。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-6 bg-accent-100/80 rounded-xl p-5 border border-accent-200">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-accent-600 text-base"></i>
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">
                      <strong>重要提示：</strong>上述特殊退款情形须在事件发生后30个自然日内提出申请，逾期将不予受理。所有提供的证明文件必须真实有效，如有伪造，我们将保留追究法律责任的权利。
                    </p>
                  </div>
                </div>
              </div>

              {/* Section 3 - Application Process */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-6">3. 退款申请流程</h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 text-sm font-semibold flex-shrink-0">1</div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">提交申请</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">发送邮件至 support@aifuture.academy，邮件中请注明：注册邮箱、订单编号、退款原因分类，并附上所有相关证明文件的清晰扫描件或照片。</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 text-sm font-semibold flex-shrink-0">2</div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">材料审核</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">客服团队将在3-5个工作日内完成材料初审。如需补充材料，会通过邮件通知。审核期间可能会致电核实情况，请保持电话畅通。</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 text-sm font-semibold flex-shrink-0">3</div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">审批决议</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">审核通过后，我们将在5个工作日内邮件通知审批结果。通过的申请将说明退款金额和到账时间。</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4 bg-background-100 rounded-xl p-5">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 text-sm font-semibold flex-shrink-0">4</div>
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 mb-1">退款到账</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">审批通过后，款项将在7-15个工作日内按原支付方式退回。退款金额将根据已完成的课程进度进行折算——已学习内容占比越高，退款比例越低。退款完成后，课程学习权限将被立即关闭。</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 4 - Non-Eligible */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">4. 不予退款的情形</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  以下情况不属于特殊退款范畴，申请将不予受理：
                </p>
                <ul className="space-y-2.5">
                  <li className="flex items-start gap-2.5 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5 flex-shrink-0">•</span>
                    <span>个人主观原因——如"课程太难"、"没时间学"、"改变主意"、"课程不合预期"等</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5 flex-shrink-0">•</span>
                    <span>工作变动——如加班、出差、换工作等个人时间安排问题</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5 flex-shrink-0">•</span>
                    <span>未提供有效证明文件的申请</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5 flex-shrink-0">•</span>
                    <span>超过事发后30天提交的申请</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5 flex-shrink-0">•</span>
                    <span>通过促销活动、优惠券或赠送方式获得的课程</span>
                  </li>
                  <li className="flex items-start gap-2.5 text-sm text-foreground-600">
                    <span className="text-foreground-300 mt-0.5 flex-shrink-0">•</span>
                    <span>已完成全部课程内容学习的订单</span>
                  </li>
                </ul>
              </div>

              {/* Section 5 - Installment */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">5. 分期付款说明</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  选择分期付款的学员，已支付的分期款项将按照上述政策统一处理。如退款申请获批，剩余未支付的分期计划将自动取消，不再产生后续扣款。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  分期服务产生的手续费（如有）不在退款范围内。
                </p>
              </div>

              {/* Section 6 - Policy Changes */}
              <div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-4">6. 政策变更</h2>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  bbgpt.online保留随时更新本退款政策的权利。政策修订将在本页面发布后立即生效。建议你定期查看此页面以了解最新政策。如涉及重大变更，我们将通过邮件通知所有现有学员。
                </p>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="mt-16 bg-foreground-900 rounded-2xl p-8 text-center">
              <h3 className="font-heading text-xl text-background-50 mb-3">有特殊情况需要退款？</h3>
              <p className="text-sm text-background-300 mb-6">请仔细阅读上述退款条件，符合条件的可通过邮件提交申请</p>
              <a
                href="mailto:support@aifuture.academy"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-foreground-950 font-medium rounded-full hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </div>
                support@aifuture.academy
              </a>
            </div>
          </article>
        </section>
      </main>
      <Footer />
    </>
  );
}